var map = {
	"./conductor-0.png": 1546,
	"./conductor-1.png": 1379,
	"./conductor-2.png": 9400,
	"./conductor-3.png": 7793,
	"./conductor-4.png": 3230,
	"./conductor-5.png": 9015,
	"./fork-0.png": 6647,
	"./fork-1.png": 6654,
	"./fork-2.png": 5429,
	"./fork-3.png": 7916,
	"./fork-4.png": 1523,
	"./fork-5.png": 762,
	"./hall-0.png": 9718,
	"./hall-1.png": 8463,
	"./hall-2.png": 6004,
	"./hall-3.png": 7133,
	"./hall-4.png": 4338,
	"./hall-5.png": 7995,
	"./metronome-0.png": 3169,
	"./metronome-1.png": 8952,
	"./metronome-2.png": 4227,
	"./metronome-3.png": 3002,
	"./metronome-4.png": 9509,
	"./metronome-5.png": 4060,
	"./principal-0.png": 9623,
	"./principal-1.png": 1310,
	"./principal-2.png": 8661,
	"./principal-3.png": 9564,
	"./principal-4.png": 9731,
	"./principal-5.png": 2154,
	"./stand-0.png": 4513,
	"./stand-1.png": 6120,
	"./stand-2.png": 4451,
	"./stand-3.png": 4618,
	"./stand-4.png": 6677,
	"./stand-5.png": 5052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1644;